export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (typeof window.gtag === "function") window.gtag("event", name, params);
  if (typeof window.fbq === "function") window.fbq("trackCustom", name, params);
};
